module.exports = __webpack_public_path__ + "static/media/reward_activities.5655f08a.png";